import React from 'react';
import { Box, BoxProps, Stack, Heading, Text, Link } from '@chakra-ui/react';
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../../constants';

const SidebarHeader = ({ children }: { children: string }) => (
  <Heading fontSize="2xl" pb="4">
    {children}
  </Heading>
);

const LinksSidebar = (props: BoxProps) => (
  <Box {...props}>
    <SidebarHeader>Helpful Links</SidebarHeader>
    <Stack spacing="0.5" mb="4">
      <Link href="/trust-center/">Trust Center</Link>
      <Link href="/privacy/">Privacy Policy</Link>
      <Link href="/terms_of_use/">Terms of Use</Link>
      <Link href="/cookie-policy/">Cookie Policy</Link>
    </Stack>
    <SidebarHeader>Have Questions?</SidebarHeader>
    <Stack spacing="0.5">
      <Text>
        If you have questions about these terms or anything else about HOVER,
        contact us:
      </Text>
      <Link href={`mailto:${SUPPORT_EMAIL}`} display="block">
        {SUPPORT_EMAIL}
      </Link>
      <Link href={`tel:${SUPPORT_PHONE}`} display="block">
        {SUPPORT_PHONE}
      </Link>
    </Stack>
  </Box>
);

export default LinksSidebar;
